import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OpportunityScannerState {
  private isLoadingOpportunities$ = new BehaviorSubject<boolean>(false);
  isLoadingOpportunitiesValue = this.isLoadingOpportunities$.asObservable();

  public get isLoadingOpportunities(): boolean {
    return this.isLoadingOpportunities$.value;
  }
  public set isLoadingOpportunities(status: boolean) {
    this.isLoadingOpportunities$.next(status);
  }

  private isSuggestionsOpen$ = new BehaviorSubject<boolean>(false);
  isSuggestionsOpenValue = this.isSuggestionsOpen$.asObservable();

  public get isSuggestionsOpen(): boolean {
    return this.isSuggestionsOpen$.value;
  }
  public set isSuggestionsOpen(status: boolean) {
    this.isSuggestionsOpen$.next(status);
  }

  private openSuggestionOnLoad$ = new BehaviorSubject<boolean>(false);
  openSuggestionOnLoadValue = this.openSuggestionOnLoad$.asObservable();

  public get openSuggestionOnLoad(): boolean {
    return this.openSuggestionOnLoad$.value;
  }
  public set openSuggestionOnLoad(status: boolean) {
    this.openSuggestionOnLoad$.next(status);
  }

  private isApplySuggestions$ = new BehaviorSubject<object>(null);
  isApplySuggestionsValue = this.isApplySuggestions$.asObservable();

  public get isApplySuggestions(): object {
    return this.isApplySuggestions$.value;
  }
  public set isApplySuggestions(status: object) {
    this.isApplySuggestions$.next(status);
  }

  private aiSuggestion$ = new BehaviorSubject<object>(null);
  aiSuggestionValue = this.aiSuggestion$.asObservable();
  public get aiSuggestion(): object {
    return this.aiSuggestion$.value;
  }
  public set aiSuggestion(aiSuggestionData: object) {
    this.aiSuggestion$.next(aiSuggestionData);
  }

  private opportunityList$ = new BehaviorSubject<Array<any>>([]);
  opportunityListValue = this.opportunityList$.asObservable();
  public get opportunityList(): Array<any> {
    return this.opportunityList$.value;
  }
  public set opportunityList(recommendedData: Array<any>) {
    this.opportunityList$.next(recommendedData);
  }

  private opportunityCount$ = new BehaviorSubject<number>(0);
  opportunityCountValue = this.opportunityCount$.asObservable();
  public get opportunityCount(): number {
    return this.opportunityCount$.value;
  }
  public set opportunityCount(count: number) {
    this.opportunityCount$.next(count);
  }

  private zoningSuggestion$ = new BehaviorSubject<object>(null);
  zoningSuggestionValue = this.zoningSuggestion$.asObservable();
  public get zoningSuggestion(): object {
    return this.zoningSuggestion$.value;
  }
  public set zoningSuggestion(zoningSuggestion: object) {
    this.zoningSuggestion$.next(zoningSuggestion);
  }
  
    private zoningSuggestionForm$ = new BehaviorSubject<object>(null);
  zoningSuggestionFormValue = this.zoningSuggestionForm$.asObservable();
  public get zoningSuggestionForm(): object {
    return this.zoningSuggestionForm$.value;
  }
  public set zoningSuggestionForm(zoningSuggestionForm: object) {
    this.zoningSuggestionForm$.next(zoningSuggestionForm);
  }

  private zoningSuggestionLoading$ = new BehaviorSubject<boolean>(false);
  zoningSuggestionLoadingValue = this.zoningSuggestionLoading$.asObservable();
  public get zoningSuggestionLoading(): boolean {
    return this.zoningSuggestionLoading$.value;
  }
  public set zoningSuggestionLoading(value: boolean) {
    this.zoningSuggestionLoading$.next(value);
  }

  private aiSuggestionLoading$ = new BehaviorSubject<boolean>(false);
  aiSuggestionLoadingValue = this.aiSuggestionLoading$.asObservable();
  public get aiSuggestionLoading(): boolean {
    return this.aiSuggestionLoading$.value;
  }
  public set aiSuggestionLoading(value: boolean) {
    this.aiSuggestionLoading$.next(value);
  }

  private selectedOpportunityModel$ = new BehaviorSubject<string>(null);
  selectedOpportunityModelValue = this.selectedOpportunityModel$.asObservable();
  public get opportunityModel() {
    return this.selectedOpportunityModel$.value;
  }
  public set opportunityModel(value: string) {
    this.selectedOpportunityModel$.next(value);
  }

  private savedSuggestionModel$ = new BehaviorSubject<object>(null);
  savedSuggestionModelValue = this.savedSuggestionModel$.asObservable();
  public get savedSuggestion(): object {
    return this.savedSuggestionModel$.value;
  }
  public set savedSuggestion(value: object) {
    this.savedSuggestionModel$.next(value);
  }

  

  private comparableList$ = new BehaviorSubject<Array<any>>([]);
  comparableListValue = this.comparableList$.asObservable();
  public get comparableList(): Array<any> {
    return this.comparableList$.value;
  }
  public set comparableList(recommendedData: Array<any>) {
    this.comparableList$.next(recommendedData);
  }

  private createdOpportunity$ = new BehaviorSubject<object>(null);
  createdOpportunityValue = this.createdOpportunity$.asObservable();
  public get createdOpportunity(): object {
    return this.createdOpportunity$.value;
  }
  public set createdOpportunity(recommendedData: object) {
    this.createdOpportunity$.next(recommendedData);
  }

  private opportunityClickedSubject$ = new BehaviorSubject<boolean>(false);
  opportunityClicked$ = this.opportunityClickedSubject$.asObservable();
  
  public get isOpportunityClicked(): boolean {
    return this.opportunityClickedSubject$.value;
  }
  
  public set isOpportunityClicked(value: boolean) {
    this.opportunityClickedSubject$.next(value);
  }

  private selectedOpportunity$ = new BehaviorSubject<object>(null);
  selectedOpportunityValue = this.selectedOpportunity$.asObservable();
  public get selectedOpportunity(): object {
    return this.selectedOpportunity$.value;
  }
  public set selectedOpportunity(recommendedData: object) {
    this.selectedOpportunity$.next(recommendedData);
  }

  private editedOpportunity$ = new BehaviorSubject<object>(null);
  editedOpportunityValue = this.editedOpportunity$.asObservable();
  public get editedOpportunity(): object {
    return this.editedOpportunity$.value;
  }
  public set editedOpportunity(recommendedData: object) {
    this.editedOpportunity$.next(recommendedData);
  }

  private selectedTabIndex$ = new BehaviorSubject<number>(0);
  selectedTabIndexValue = this.selectedTabIndex$.asObservable();
  public get selectedTabIndex(): number {
    return this.selectedTabIndex$.value;
  }
  public set selectedTabIndex(count: number) {
    this.selectedTabIndex$.next(count);
  }

  private selectedOption$ = new BehaviorSubject<string>(null);
  selectedOptionValue = this.selectedTabIndex$.asObservable();
  public get selectedOption(): string {
    return this.selectedOption$.value;
  }
  public set selectedOption(option: string) {
    this.selectedOption$.next(option);
  }
}
